// Wrappers para /api/admin/emails*.

import { apiFetch } from './api';

export interface EmailLogItem {
  id: number;
  template: string;
  recipient_email: string;
  recipient_user_id: number | null;
  from_email: string;
  subject: string;
  status: 'mock' | 'queued' | 'sent' | 'failed';
  provider: string | null;
  provider_message_id: string | null;
  error_message: string | null;
  created_at: string;
}

export interface EmailLogDetail extends EmailLogItem {
  html: string;
  text: string | null;
  metadata: unknown;
}

export interface EmailFilters {
  template?: string;
  status?: 'mock' | 'queued' | 'sent' | 'failed';
  recipient?: string;
  page?: number;
  page_size?: number;
}

function toQuery(filters: EmailFilters): string {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v !== undefined && v !== null && v !== '') params.set(k, String(v));
  }
  return params.toString() ? `?${params.toString()}` : '';
}

export async function listEmails(filters: EmailFilters): Promise<{ items: EmailLogItem[]; total: number; page: number; page_size: number }> {
  const r = await apiFetch<{ status: 'ok'; items: EmailLogItem[]; total: number; page: number; page_size: number }>(`/admin/emails${toQuery(filters)}`);
  return { items: r.items, total: r.total, page: r.page, page_size: r.page_size };
}

export async function getEmail(id: number): Promise<EmailLogDetail> {
  const r = await apiFetch<{ status: 'ok'; email: EmailLogDetail }>(`/admin/emails/${id}`);
  return r.email;
}
